module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "normal"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "no-padding"
  }, [_vm._t("bottom")], 2), _vm._v(" "), _c('div', {
    staticClass: "filter-btns"
  }, [_vm._t("btns")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd57de3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/business/list/rtListFilter.vue
// module id = 1462
// module chunks = 124